module.exports = __webpack_public_path__ + "img/left-chevron-green.f62b1204.svg";